// extracted by mini-css-extract-plugin
module.exports = {"bgcontainer":"Banner_bgcontainer__2co2-","bgdrop":"Banner_bgdrop__3Xp2U","emptext":"Banner_emptext__3Wp1L"};